"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileMediaQuery = void 0;
var react_1 = __importDefault(require("react"));
var ModalBase_1 = __importDefault(require("./ModalBase"));
var ModalContent_1 = __importDefault(require("./ModalContent"));
exports.mobileMediaQuery = '(max-width: 480px)';
var Modal = function (_a) {
    var actions = _a.actions, backText = _a.backText, backDataTestId = _a.backDataTestId, backButtonProps = _a.backButtonProps, children = _a.children, id = _a.id, onBack = _a.onBack, onClose = _a.onClose, open = _a.open, title = _a.title, hideTitle = _a.hideTitle, titleTypographyProps = _a.titleTypographyProps, fullScreen = _a.fullScreen, disableCloseButton = _a.disableCloseButton, disableBackText = _a.disableBackText, _b = _a.backTextAutoFocus, backTextAutoFocus = _b === void 0 ? false : _b, props = __rest(_a, ["actions", "backText", "backDataTestId", "backButtonProps", "children", "id", "onBack", "onClose", "open", "title", "hideTitle", "titleTypographyProps", "fullScreen", "disableCloseButton", "disableBackText", "backTextAutoFocus"]);
    return (react_1.default.createElement(ModalBase_1.default, __assign({ fullWidth: true, fullScreen: fullScreen, open: open, onClose: onClose, id: id }, props),
        react_1.default.createElement(ModalContent_1.default, { actions: actions, backText: backText, backDataTestId: backDataTestId, backButtonProps: backButtonProps, id: id, onBack: onBack, onClose: onClose, title: title, hideTitle: hideTitle, titleTypographyProps: titleTypographyProps, fullScreen: fullScreen, disableCloseButton: disableCloseButton, disableBackText: disableBackText, backTextAutoFocus: backTextAutoFocus }, children)));
};
exports.default = Modal;
//# sourceMappingURL=index.js.map